import { graphql } from '@client/graphql/types';

export const OnlineOrderBranchSettingFragment = graphql(`
  fragment OnlineOrderBranchSettingItem on OnlineOrderBranchConfiguration {
    branchID
    menuID

    pickupEnable
    autoPickupConfirm

    defaultPreparingTime
    pickupLeadMinutes
    deliveryLeadMinutes

    pickupDiscountAmount
    pickupDiscountType
    capacityEnabled

    deliveryDiscountAmount
    deliveryDiscountType

    deliveryPause
    pickupPause

    categoryStyle

    deliveryEnable
    autoDeliveryConfirm
    deliveryRadiusLimit
    minimumOrderAmountForDelivery
    deliveryTableData {
      id
      deliveryDistance
      deliveryTime
      deliveryFee
      minimumOrderBasePrice
    }
    printToKitchen
    sendCustomerEmail
    happyHourMode

    stripeAPIKeyId
    paymentMethods
    template

    onlinePaymentMethods {
      id
      name
      fields {
        key
        value
      }
      qrImageOrigin
      qrImageThumbnail
      instructions
    }
  }
`);
